import { lang } from '@umu/ukit-lang';
import { randomRange } from '@umu/umu-util';
import { isEnterpriseUser } from '../../../services/accountService';
import { FULL_USER_LEVEL } from '../../../@utils/userAchievementUtil';

/**
 * lv5 激励文案列表，出的时候随机出
 */
const encourageList = [
    lang('查看课程下的发言，为他人点赞，积累更多UP值，等级升得更快更高。'),
    lang('你这么优秀，相信你的伙伴也很棒，邀请他们一起学习课程，创建课程，等级升得更高。'),
    lang('坚持每日登录打卡，积累更多UP值，新的成就正在向你招手。'),
    lang('获得成就的终极秘籍：多点赞，勤发言，不仅可以增长UP值，还有机会获得勋章。'),
    lang('看完微课，不要立刻走掉，填写星级评价，可以挖掘隐藏UP值！期待你的等级越来越高。'),
    lang('坚持来自无限的热爱，充满热情又是美好的一天，再完成一个小节，积累更多UP值吧。'),
    lang('坚持了这么久，还记得最初的动力吗？多看文章，勤学微课，等级升得更高。'),
    lang('听说隔壁的同学准备努力赶超你，快去学习微课，发言点赞，积累UP值，甩掉他们。'),
    lang('勤奋塑造无限可能，尝试着创建几门课程，等级升得更快。'),
    lang('告诉你个秘密，创建学习项目，可以获得更多UP值，等级升得更快。'),
    lang('看到精彩的发言，回复一句鼓励话语，支持对方的同时，还会收获更多UP值，等级升得更高。'),
    lang('偷偷告诉你，连续每日登录，收获的UP值更多，等级升的更快。'),
];

const previlegeEncourageMap: { [index: number]: string } = {
    [FULL_USER_LEVEL]: lang(
        '你解锁了双向视频会议功能，可以随时组织多达百人、四十分钟一节的双向视频会议模式进行教学，这就试试吧！',
    ),
};
/**
 * 企业版用户随机出一个
 * 非企业版用户，在有特权等级时，提示对应文案
 */
function getEncourage(userLevel: number) {
    const len = encourageList.length;
    const randomIndex = randomRange(0, len - 1);

    let ret = encourageList[randomIndex];

    if (!isEnterpriseUser()) {
        ret = previlegeEncourageMap[userLevel] || ret;
    }

    return ret;
}

const previlegeMap: { [index: number]: string } = {
    [FULL_USER_LEVEL]: lang('双向会议特权'),
};

function getPrivilege(userLevel: number) {
    if (isEnterpriseUser()) {
        return;
    }
    return previlegeMap[userLevel];
}

export { getEncourage, getPrivilege };
